import styled from 'styled-components';
import { Spin as AntSpin } from 'components/UI/Spin';

export const Spin = styled(AntSpin)`
  height: 52px;
  display: inline-flex !important;
  align-items: center;
`;
